import {createBrowserRouter, Navigate} from "react-router-dom";
import LoginScreen from "../screens/login/login_screen";
import DashboardScreen from "../screens/dashboard/dashboard_screen";
import {getUser} from "../services/login/auth_service";
import DataTablesScreen from "../screens/dashboard/data_tables/DataTablesScreen";
import UploadWebpScreen from "../screens/dashboard/upload_webps/UploadWebpScreen";
import FeedbackScreen from "../screens/dashboard/feedback/FeedbackScreen";
import CategoriesScreen from "../screens/dashboard/categories/categories_screen";
import VersionControlScreen from "../screens/dashboard/version_control/VersionControl";
import VideoToWebpScreen from "../screens/dashboard/video_to_webp/video_to_webp_screen";
import DiscourseDataTableScreen from "../screens/dashboard/discourse/DiscourseDataTableScreen.jsx";
import DiscourseType from "../screens/dashboard/discourse/DiscourseType.jsx";
// import {ReactComponent as MyIcon} from '../assets/svg/Troll-Face.svg'

import HomeScreen from "../screens/public/HomeScreen";


import QuizScreen from "../screens/public/quiz/QuizScreen";
import QuizSubScreenOne from "../screens/public/quiz/QuizSubScreenOne";

import PublicFeedbackScreen from "../screens/public/feedback/PublicFeedbackScreen.js";

import SignsScreen from "../screens/public/signs/SignsScreen";
import SignsSubScreenOne from '../screens/public/signs/SignsSubScreenOne';
import SignsSubScreenTwo from '../screens/public/signs/SignsSubScreenTwo';
import SignSearchResult from '../screens/public/signs/SignSearchResult';

import DiscourseScreenMain from "../screens/public/discourse/DiscourseScreenMain.jsx";
import DiscourseSearchResult from "../screens/public/discourse/DiscourseSearchResult.jsx"
import DiscourseSubScreenOne from "../screens/public/discourse/DiscourseSubScreenOne.jsx";
import DiscourseSubScreenTwo from "../screens/public/discourse/DiscourseSubScreenTwo.jsx";



// const ProtectedRoute = ({user, children}) => {
//     if (!user) {
//         return <Navigate to="/login" />;
//     }
//     return children;
// };
const ProtectedRouteWrapper = ({ children }) => {
    const user = getUser();

    if (!user) {
        return <Navigate to="/login" />;
    }
    return children;
};

export const router = createBrowserRouter([
    // { path: "/", element: <Navigate to="/login" /> },
    { path: "/", element: <Navigate to="/home" /> },
    { path: "/login", element: <LoginScreen /> },

    // ✅ Public layout route with children
    {
        path: "/home",
        element: <HomeScreen />,
        children: [
            { index: true, element: <Navigate to="signsCategory" /> }, // redirect /public to /public/signs
            { path: "signsCategory", element: <SignsScreen /> },
            { path: "signsCategory/:category", element: <SignsSubScreenOne /> },
            { path: "signsCategory/:category/:sign", element: <SignsSubScreenTwo /> },

            {path: "signsCategory/result", element: <SignSearchResult/>},

            { path: "discourse", element: <DiscourseScreenMain /> },

            { path: "discourse/:type", element: <DiscourseSubScreenOne /> },
            { path: "discourse/:type/:discourseTitle", element: <DiscourseSubScreenTwo /> },

            { path: "discourse/result", element: <DiscourseSearchResult /> },
            // { path: "discourse/stories", element: <StoryScreen /> },
            // { path: "discourse/stories/:discourseTitle", element: <StorySubScreenOne /> },
            // { path: "discourse/sentences", element: <SentenceScreen /> },
            // { path: "discourse/sentences/:discourseTitle", element: <SentenceSubScreenOne /> },
            // { path: "discourse/phrases", element: <PhraseScreen /> },
            // { path: "discourse/phrases/:discourseTitle", element: <PhraseSubScreenOne /> },

            { path: "quiz", element: <QuizScreen /> },
            { path: "quiz/:category", element: <QuizSubScreenOne /> },
            { path: "feedback", element: <PublicFeedbackScreen /> },

            { path: "*", element: <div>Page not found</div> },
        ],
    },
    {
        path: "/dashboard",
        element: (
            // <ProtectedRoute user={getUser()}>
            //     <DashboardScreen/>
            // </ProtectedRoute>
            <ProtectedRouteWrapper>
                <DashboardScreen />
            </ProtectedRouteWrapper>
        ),
        children: [
             {path: "version-control", element: <VersionControlScreen/>},
            {
                path: "upload-webp",
                element: <UploadWebpScreen/>,
            },
            {
                path: "data-tables",
                element: <DataTablesScreen/>,
            },
            {path: "feedback", element: <FeedbackScreen/>},
            {path: "categories", element: <CategoriesScreen/>},
           
            {path: "video-to-webp", element: <VideoToWebpScreen/>},

              {
                path: "discourse-type",
                element: <DiscourseType/>,
            },

            {
                path: "discourse-data-table",
                element: <DiscourseDataTableScreen/>,
            },
            {
                path: "*",
                element: <>Page not found</>,
            },
        ],
    },
    {
        path: "*",
        element: <div style={{display: 'flex'}}>
            {/*<MyIcon/>*/}
            <h1>Page not found</h1>
        </div>
    }
],

);
